import {useStoreon} from 'storeon/react';
import {IEvents, IState} from 'src/store';
import {ArrayOfColors, colors, RoofColors} from "src/parameters/colors";
import {RoofCoating, RoofProfile, RoofThickness, RoofType} from "../../../types/types";

export const usePresenter = () => {
    const {dispatch, roofStore} = useStoreon<IState, IEvents>('roofStore');

    const {profileType, metalTileName, coatingName, thicknessName} = roofStore

    const getColorsArray = (): ArrayOfColors => {
        const isMetalRoof  = profileType === RoofProfile.Metal
        const isProfRoof   = profileType === RoofProfile.Prof
        const isPolyester  = coatingName === RoofCoating.Polyester && metalTileName === RoofType.Lamonterra
        const isZink       = coatingName === RoofCoating.Zinc
        const isPolyNorman = coatingName === RoofCoating.Poly_Norman

        if (isMetalRoof) {
            if (isPolyester) {
                const options: { [key: string]: ArrayOfColors } = {
                    [RoofThickness.THICK_40]: colors[RoofColors.GROUP1],
                    [RoofThickness.THICK_45]: colors[RoofColors.GROUP2],
                }
                return options[thicknessName] || colors[RoofColors.DEFAULT]
            } else {
                const options: { [key: string]: ArrayOfColors } = {
                    [RoofCoating.Norman]:     colors[RoofColors.GROUP3],
                    [RoofCoating.Purman]:     colors[RoofColors.GROUP4],
                    [RoofCoating.VikingMP]:   colors[RoofColors.GROUP5],
                    [RoofCoating.PureTechMat]:colors[RoofColors.GROUP13],
                    [RoofCoating.Valori]:     colors[RoofColors.GROUP14],
                    [RoofCoating.Puretan]:    colors[RoofColors.GROUP15],
                    [RoofCoating.MattMP]:     colors[RoofColors.GROUP16],
                }
                return options[coatingName] || colors[RoofColors.DEFAULT]
            }
        } else if (isProfRoof) {
            // Polyester new thicknesses (0.5–1.2) — check BEFORE isPolyester
            const newPolyesterThicknesses: string[] = [
                RoofThickness.THICK_50,
                RoofThickness.THICK_80,
                RoofThickness.THICK_90,
                RoofThickness.THICK_100,
                RoofThickness.THICK_120,
            ]
            if (coatingName === RoofCoating.Polyester && newPolyesterThicknesses.includes(thicknessName)) {
                return colors[RoofColors.GROUP19]
            }

            if (isPolyester) {
                const options: { [key: string]: ArrayOfColors } = {
                    [RoofThickness.THICK_40]: colors[RoofColors.GROUP6],
                    [RoofThickness.THICK_45]: colors[RoofColors.GROUP7],
                }
                return options[thicknessName] || colors[RoofColors.DEFAULT]
            } else if (isZink) {
                const options: { [key: string]: ArrayOfColors } = {
                    [RoofThickness.THICK_40]: colors[RoofColors.GROUP9],
                    [RoofThickness.THICK_45]: colors[RoofColors.GROUP10],
                }
                return options[thicknessName] || colors[RoofColors.DEFAULT]
            } else if (isPolyNorman) {
                return colors[RoofColors.GROUP8]
            }

            // New prof coatings
            const profMap: { [key: string]: ArrayOfColors } = {
                [RoofCoating.Purman]:           colors[RoofColors.GROUP4],
                [RoofCoating.VikingMP]:         colors[RoofColors.GROUP5],
                [RoofCoating.PureTechMat]:      colors[RoofColors.GROUP13],
                [RoofCoating.Valori]:           colors[RoofColors.GROUP14],
                [RoofCoating.Puretan]:          colors[RoofColors.GROUP15],
                [RoofCoating.MattMP]:           colors[RoofColors.GROUP16],
                [RoofCoating.VikingMPStandard]: colors[RoofColors.GROUP17],
                [RoofCoating.SteelMatt]:        colors[RoofColors.GROUP18],
                [RoofCoating.Ecosteel]:         colors[RoofColors.GROUP20],
            }
            if (profMap[coatingName]) {
                return profMap[coatingName]
            }
        }
        return colors[RoofColors.DEFAULT]
    }

    const setColorID = (id: number) => {
        dispatch('roof/set-color-id', {colorID: id});
    };

    return {
        selectedColor: roofStore.colorID,
        setColorID,
        colors: getColorsArray(),
    };
};
